import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';

const Assests = () => {
    const [isCopied, setIsCopied] = useState(false);
    const firstBan = "<a target='_blank href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_728x90.jpg' width='728' height='90' border='0' title='Virtual Private Server'></a>";
    const secondBan = "<a target='_blank' href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_468x60.jpg' width='468' height='60' border='0' title='Virtual Private Server'></a>";
    const thirdBan = "<a target='_blank' href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_300x250.jpg' width='300' height='250' border='0' title='Virtual Private Server'></a>";
    const fourthBan = "<a target='_blank' href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_234x60.jpg' width='234' height='60' border='0' title='Virtual Private Server'></a>";
    const fifthBan = "<a target='_blank' href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_125x125.jpg' width='125' height='125' border='0' title='Virtual Private Server'></a>";
    const sixthBan = "<a target='_blank' href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_120x240.jpg' width='120' height='240' border='0' title='Virtual Private Server'></a>";
    const seventhBan = "<a target='_blank' href='https://www.idrivecompute.com'><img src='https://www.idrivecompute.com/webapp/images/compute_120x60.jpg' width='120' height='60' border='0' title='Virtual Private Server'></a>";
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const copyToclipboard = (event, text) => {
        event.preventDefault();
        setIsCopied(true);
        var textField = document.createElement('textarea');
        textField.innerText = text;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
    };

    return (
        <React.Fragment>
            <section class="referralModule_wrapper ">
                <div class="assets_section">
                    <h2 class="heading_title">IDrive<sup>®</sup> Compute Promotional Banners</h2>
                    <div class="banner_wrp">
                        <p class="promo_txt">Select the promotional graphic(s) that best suits your requirement.</p>
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_728x90.jpg" />
                                <p class="img_size">size 728x90  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#1" data-tip onClick={ (e) => { copyToclipboard(e, firstBan); } } onMouseLeave={ (e) => { setIsCopied(false); } }>Copy Code</span>
                                    <ReactTooltip id='#1' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_728x90.jpg" width="728" height="90" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="banner_wrp">
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_468x60.jpg" />
                                <p class="img_size">size 468x60  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#2" data-tip onClick={ (e) => { copyToclipboard(e, secondBan); } } onMouseLeave={ (e) => setIsCopied(false) }>Copy Code</span>
                                    <ReactTooltip id='#2' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_468x60.jpg" width="468" height="60" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="banner_wrp">
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_300x250.jpg" />
                                <p class="img_size">size 300x250  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#3" data-tip onClick={ (e) => { copyToclipboard(e, thirdBan); } } onMouseLeave={ (e) => setIsCopied(false) }>Copy Code</span>
                                    <ReactTooltip id='#3' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_300x250.jpg" width="300" height="250" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="banner_wrp">
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_234x60.jpg" />
                                <p class="img_size">size 234x60  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#4" data-tip onClick={ (e) => { copyToclipboard(e, fourthBan); } } onMouseLeave={ (e) => setIsCopied(false) }>Copy Code</span>
                                    <ReactTooltip id='#4' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_234x60.jpg" width="234" height="60" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="banner_wrp">
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_125x125.jpg" />
                                <p class="img_size">size 125x125  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#3" data-tip onClick={ (e) => { copyToclipboard(e, fifthBan); } } onMouseLeave={ (e) => setIsCopied(false) }>Copy Code</span>
                                    <ReactTooltip id='#3' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_125x125.jpg" width="125" height="125" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="banner_wrp">
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_120x240.jpg" />
                                <p class="img_size">size 120x240  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#3" data-tip onClick={ (e) => { copyToclipboard(e, sixthBan); } } onMouseLeave={ (e) => setIsCopied(false) }>Copy Code</span>
                                    <ReactTooltip id='#3' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_120x240.jpg" width="120" height="240" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="banner_wrp">
                        <div class="banner_blk">
                            <div class="img_wrp">
                                <img src="https://www.idrivecompute.com/webapp/images/compute_120x60.jpg" />
                                <p class="img_size">size 120x60  </p>
                            </div>
                            <p class="web_txt">Web banner HTML code</p>
                            <div class="code_blk">
                                <div class="cbOut">
                                    <span class="copy_btn" data-for="#3" data-tip onClick={ (e) => { copyToclipboard(e, seventhBan); } } onMouseLeave={ (e) => setIsCopied(false) }>Copy Code</span>
                                    <ReactTooltip id='#3' effect='solid' place='top' >{ isCopied ? "Copied" : "Copy" }</ReactTooltip>
                                    <div class="code_blkInner">
                                        <span class="code_link">&lt;a target="_blank" href="https://www.idrivecompute.com"&gt;&lt;img src="https://www.idrivecompute.com/webapp/images/compute_120x60.jpg" width="120" height="60" border="0" title="Virtual Private Server"&lt;/a&gt;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </React.Fragment>
    );
};

export default Assests;